import { forwardRef } from "react";
import Link from "next/link";
import { blue, gray, green, orangeDark, pink, purple } from "../../../../theme";
import styles from "./desktopNavMenuItem.module.scss";

export const DesktopNavMenuItem = forwardRef((props: Props, ref: any) => {
  const colors: any = {
    pink: pink,
    blue: blue,
    green: green,
    orangedark: orangeDark,
    gray: gray,
    purple: purple,
  };

  return (
    <Link
      href={props.url}
      className={styles.link}
      onClick={props.onClick}
      ref={ref}
    >
      {props.icon}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          padding: "0px",
          gap: "4px",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            gap: "8px",
            alignItems: "center",
          }}
        >
          <p className={styles.title}>{props.title}</p>
          {props.badgeColor && (
            <div
              style={{
                display: "flex",
                padding: "2px 8px",
                alignItems: "center",
                borderRadius: "16px",
                mixBlendMode: "multiply",
                backgroundColor: colors[props.badgeColor][50],
              }}
            >
              <p
                className={styles.badgeText}
                style={{ color: colors[props.badgeColor][600] }}
              >
                {props.badgeText}
              </p>
            </div>
          )}
        </div>
        {props.desc && <p className={styles.desc}>{props.desc}</p>}
      </div>
    </Link>
  );
});

interface Props {
  title: string;
  desc?: string;
  icon?: JSX.Element;
  url: string;
  badgeText?: string;
  badgeColor?: "green" | "blue" | "red" | "gray";
  onClick?: () => void;
}
